import EventBus from '@/vue-caas/views/process/component/event-bus.js';

function isEqualExcept(objA, objB, ignoreKeys = []) {
  function compare(a, b) {
    if (a === b) return true;

    if (a == null || b == null) return false;

    if (typeof a !== 'object' || typeof b !== 'object') {
      return a === b;
    }

    // Array
    if (Array.isArray(a)) {
      if (!Array.isArray(b)) return false;
      if (a.length !== b.length) return false;

      for (let i = 0; i < a.length; i++) {
        if (!compare(a[i], b[i])) return false;
      }
      return true;
    }

    // Object
    const keysA = Object.keys(a).filter((k) => !ignoreKeys.includes(k));
    const keysB = Object.keys(b).filter((k) => !ignoreKeys.includes(k));

    for (const key of keysA) {
      if (!keysB.includes(key)) return false;
      if (!compare(a[key], b[key])) return false;
    }

    for (const key of keysB) {
      if (!keysA.includes(key)) return false;
    }

    return true;
  }

  return compare(objA, objB);
}

function increaseSuffix(list, field, name) {
  const base = name.replace(/\s*\(\d+\)$/, '');

  const max = Math.max(
    0,
    ...list
      .map((o) => o[field])
      .filter((n) => n && n.replace(/\s*\(\d+\)$/, '') === base)
      .map((n) => (n.match(/\((\d+)\)$/) ? +RegExp.$1 : 0)),
  );

  return `${base} (${max + 1})`;
}

const stripSuffix = (s) => s?.replace(/\s*\(\d+\)$/, '');

function checkFolder(target, list) {
  const parts = target.FOLD_PATH.split('/');
  let currentPath = '';

  let isMissing = false;
  const missing = [];
  const existing = [];

  for (let i = 0; i < parts.length; i++) {
    currentPath = i === 0 ? parts[i] : currentPath + '/' + parts[i];
    const item = list.find((x) => x.FOLD_PATH === currentPath);

    if (!item) {
      isMissing = true;

      const parent =
        existing.length > 0
          ? existing[existing.length - 1]
          : missing.length > 0
          ? missing[missing.length - 1]
          : null;

      const PA_FOLD_ID = parent?.FOLD_ID || parent?.generatedId || null;

      const PA_FOLD_PATH = parent?.FOLD_PATH || parent?.fullPath || null;

      const PA_FOLD_LVL = parent?.FOLD_LVL || parent?.missingLevel || null;

      const FOLD_PATH = currentPath;

      const newMissing = {
        PA_FOLD_ID,
        PA_FOLD_PATH,
        PA_FOLD_LVL,
        FOLD_LVL: i + 1,
        FOLD_NAME: parts[i],
        FOLD_PATH,
      };

      missing.push(newMissing);

      existing.push({
        FOLD_ID: null,
        FOLD_PATH: FOLD_PATH,
        FOLD_LVL: i + 1,
      });
    } else {
      existing.push({
        FOLD_ID: item.FOLD_ID,
        FOLD_PATH: item.FOLD_PATH,
        FOLD_LVL: item.FOLD_LVL,
      });
    }
  }

  if (!isMissing) {
    return {
      isMissing: false,
      item: existing.at(-1),
    };
  }

  return {
    isMissing: true,
    missing,
  };
}

export const saveConfig = {
  FLT: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      if (mode === 'form') {
        await new Promise((res) => setTimeout(res, 300));
        const ok = vm.$refs.form.validate();
        if (!ok) return { ok: false, message: 'Please check required fields.' };
        if (vm.formData.fltrTpCd === 'USERDATA') {
          vm.formData.srcPttn = vm.userData.key + '|' + vm.userData.value;
        }
      }

      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.$store.getters.filterSelectBoxList.findIndex(
          (e) =>
            stripSuffix(data.fltrNm) === stripSuffix(e.fltrNm) &&
            isEqualExcept(data, e, [
              'fltrId',
              'updDt',
              'updUsrId',
              'value',
              'byProcSetup',
              'fltrNm',
              'text',
            ]),
        );

        const dupNameIndex = vm.$store.getters.filterSelectBoxList.findIndex(
          (e) =>
            !isEqualExcept(data, e, ['fltrId', 'updDt', 'updUsrId', 'value', 'byProcSetup']) &&
            data.fltrNm === e.fltrNm,
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.$store.getters.filterSelectBoxList[dupIndex];
        } else if (dupNameIndex > -1) {
          data.fltrNm = increaseSuffix(
            vm.$store.getters.filterSelectBoxList,
            'fltrNm',
            data.fltrNm,
          );
          status = 'rename';
          data.fltrId = '';
        } else {
          data.fltrId = '';
        }
      }
      if (mode === 'form') {
        status = !data.fltrId ? 'insert' : 'update';
      }
      data.byProcSetup = true;

      if (status === 'insert' || status === 'rename') {
        await vm.$store.dispatch('insertFilterFromProcSetup', data);
        data.fltrId = vm.$store.getters.filterId;
      } else if (status === 'update') {
        await vm.$store.dispatch('editFilterFromProcSetup', data);
      }

      return { status, data, id: data.fltrId };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {
      const { status, data } = ctx;

      if (mode === 'import') return;
      EventBus.$emit('refresh-list-component', {
        comId: data.fltrId,
        nodeId: vm.nodeId,
        type: vm.comTp,
      });
      if (status === 'insert') vm.$refs.RegisteredSuccess.dialog = true;
      else vm.$refs.ModifiedSuccess.dialog = true;
    },
  },
  CVT: {
    async validate(vm, data, { mode }) {
      if (mode === 'form') {
        await new Promise((res) => setTimeout(res, 300));
        vm.$refs.form.validate();
        if (!data.cvtrNm) return;
        for (let i = 0; i < vm.listConverter.length; i++) {
          if (vm.listConverter[i].cvtrTpCd === '') return;
          // FILENAME_REPLACER
          else if (vm.listConverter[i].cvtrTpCd === 'FILENAME_REPLACER') {
            if (vm.listConverter[i].srcPttn === '') return;
            else if (vm.listConverter[i].repPttn === '') return;
          }
          // FILENAME_REDUCER
          else if (vm.listConverter[i].cvtrTpCd === 'FILENAME_REDUCER') {
            if (vm.listConverter[i].nmMaxLen === '') return;
            else if (vm.listConverter[i].nmCutTp === '') return;
          }
          // FILECONTENT_REPLACER
          else if (vm.listConverter[i].cvtrTpCd === 'FILECONTENT_REPLACER') {
            if (vm.listConverter[i].srcPttn === '') return;
            if (vm.listConverter[i].skipLineCnt === '') vm.listConverter[i].skipLineCnt = '0';
            if (vm.listConverter[i].reptLineCnt === '') vm.listConverter[i].reptLineCnt = '0';
          }
          // FILE_ENVELOPER
          else if (vm.listConverter[i].cvtrTpCd === 'FILE_ENVELOPER') {
            if (vm.listConverter[i].envHdr === '' && vm.listConverter[i].envFtr === '') {
              vm.add_valid_str = 'Please insert envelope header or envelope footer.';
              vm.$refs.warningDialog.dialog = true;
              return;
            }
          }
          // FILE_DEENVELOPER
          else if (vm.listConverter[i].cvtrTpCd === 'FILE_DEENVELOPER') {
            if (
              vm.listConverter[i].envHdr === '' &&
              vm.listConverter[i].envFtr === '' &&
              vm.listConverter[i].spltPttn === ''
            ) {
              vm.add_valid_str = 'Please insert deenvelope header/footer or split pattern.';
              vm.$refs.warningDialog.dialog = true;
              return;
            }
          }
          // FILENAME_CAPTOR
          else if (vm.listConverter[i].cvtrTpCd === 'FILENAME_CAPTOR') {
            if (vm.listConverter[i].srcPttn === '') return;
            else if (vm.listConverter[i].listUserData.length === 0) {
              vm.add_valid_str = 'Please insert User Data (at least one)';
              vm.$refs.warningDialog.dialog = true;
              return;
            }
          }
          // FILECONTENT_CAPTOR
          else if (vm.listConverter[i].cvtrTpCd === 'FILECONTENT_CAPTOR') {
            if (vm.listConverter[i].srcPttn === '') return;
            else if (vm.listConverter[i].listUserData.length === 0) {
              vm.add_valid_str = 'Please insert User Data (at least one)';
              vm.$refs.warningDialog.dialog = true;
              return;
            }
            if (vm.listConverter[i].skipLineCnt === '') vm.listConverter[i].skipLineCnt = '0';
            if (vm.listConverter[i].reptLineCnt === '') vm.listConverter[i].reptLineCnt = '0';
          }
          // USERDATA_CAPTOR
          else if (vm.listConverter[i].cvtrTpCd === 'USERDATA_CAPTOR') {
            if (vm.listConverter[i].listUserData.length === 0) {
              vm.add_valid_str = 'Please insert User Data (at least one)';
              vm.$refs.warningDialog.dialog = true;
              return;
            }
          }
          // API_CAPTOR
          else if (vm.listConverter[i].cvtrTpCd === 'API_CAPTOR') {
            if (vm.listConverter[i].srcPttn === '') return;
          }
          // DB_CAPTOR
          else if (vm.listConverter[i].cvtrTpCd === 'DB_CAPTOR') {
            if (vm.listConverter[i].dBBroker === '') return;
          }
          // SHINE_CAPTOR
          else if (vm.listConverter[i].cvtrTpCd === 'SHINE_CAPTOR') {
            if (vm.listConverter[i].srcPttn === '') return;
            else if (vm.listConverter[i].repPttn === '') return;
          }

          if (
            vm.listConverter[i].cvtrTpCd.includes('CAPTOR') &&
            vm.listConverter[i].cvtrTpCd !== 'SHINE_CAPTOR'
          ) {
            vm.listConverter[i].repPttn = '';
            if (vm.listConverter[i].listUserData.length > 0) {
              let num = vm.listConverter[i].listUserData.findIndex(
                (e) => !e.key.replace(/\s/g, '').length || !e.value.replace(/\s/g, '').length,
              );
              if (num > -1) {
                vm.hideItem = false;
                let index = vm.listConverter[i].listUserData[num];
                return vm.$refs[
                  `CAPTOR_${i + '_' + index.id}${
                    !index.key.replace(/\s/g, '').length ? '' : '_' + index.id
                  }`
                ][0].focus();
              }

              let arrChk = vm.listConverter[i].listUserData.map((e) => {
                return e.key + e.value;
              });
              let isDuplicate = arrChk.findIndex((e, i) => {
                return arrChk.indexOf(e) != i;
              });

              if (isDuplicate > -1) {
                vm.add_valid_str = 'Duplicate user data.';
                vm.$refs.warningDialog.dialog = true;
                return;
              }

              let repPttn = '';
              vm.listConverter[i].listUserData.map((e) => {
                repPttn += `"${e.key}","${e.value}",`;
              });

              repPttn = repPttn.slice(0, repPttn.length - 1);
              vm.listConverter[i].repPttn = repPttn;
            }
          }

          if (vm.listConverter[i].dBBroker) {
            vm.listConverter[i].srcPttn = vm.listConverter[i].dBBroker;
          }
        }
        vm.formData.listConverter = vm.listConverter;
        vm.formData.deleteSubList = vm.deleteSubList;
      } else if (mode === 'import') {
        let listData = data.subList;
        for (let i = 0; i < listData.length; i++) {
          if (listData[i].cvtrTpCd === 'DB_CAPTOR') {
            const dupIndex = vm.$store.getters.dbBrokerSelectBoxList.findIndex(
              (e) => e.value === listData[i].srcPttn,
            );
            if (dupIndex === -1) {
              return { ok: false, message: 'cannot find DB Broker' };
            }
          }
        }
      }

      return { ok: true };
    },

    async save(vm, data, { mode }) {
      let status = 'insert';

      if (mode === 'import') {
        const dupIndex = vm.$store.getters.converterSelectBoxList.findIndex(
          (e) =>
            stripSuffix(data.cvtrNm) === stripSuffix(e.cvtrNm) &&
            isEqualExcept(data, e, [
              'cvtrId',
              'updDt',
              'updUsrId',
              'value',
              'listConverter',
              'deleteSubList',
              'listUserData',
              'byProcSetup',
              'dBBroker',
              'text',
              'cvtrNm',
            ]),
        );

        const dupNameIndex = vm.$store.getters.converterSelectBoxList.findIndex(
          (e) =>
            !isEqualExcept(data, e, [
              'cvtrId',
              'updDt',
              'updUsrId',
              'value',
              'listConverter',
              'deleteSubList',
              'listUserData',
              'byProcSetup',
              'dBBroker',
            ]) && data.cvtrNm === e.cvtrNm,
        );
        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.$store.getters.converterSelectBoxList[dupIndex];
        } else if (dupNameIndex > -1) {
          data.cvtrNm = increaseSuffix(
            vm.$store.getters.converterSelectBoxList,
            'cvtrNm',
            data.cvtrNm,
          );
          status = 'rename';
          data.cvtrId = '';
        } else {
          data.cvtrId = '';
        }
        data.listConverter = data.subList.map((item) => ({ ...item, flag: 'I' }));
        data.deleteSubList = [];
      }
      if (mode === 'form') {
        status = !data.cvtrId ? 'insert' : 'update';
        vm.isChanged = false;
      }
      data.byProcSetup = true;

      if (status === 'insert' || status === 'rename') {
        await vm.$store.dispatch('insertConverterFromProcSetup', data);
        data.cvtrId = vm.$store.getters.converterId;
      } else if (status === 'update') {
        await vm.$store.dispatch('editConverterFromProcSetup', data);
      }

      return { status, data, id: data.cvtrId };
    },
    async afterSave(vm, ctx, { mode }) {
      const { status, data } = ctx;

      if (mode === 'import') return;
      EventBus.$emit('refresh-list-component', {
        comId: data.cvtrId,
        nodeId: vm.nodeId,
        type: vm.comTp,
      });
      if (status === 'insert') vm.$refs.RegisteredSuccess.dialog = true;
      else vm.$refs.ModifiedSuccess.dialog = true;
    },
  },
  DIR: {
    // 1. VALIDATE
    async validate(vm, data, { mode, subType }) {
      if (subType === 'SYSTEM') return { ok: true };

      if (mode === 'form') {
        let folderList = vm.$store.getters.foldList;
        let systemFoldList = [];
        let foldList = [];
        folderList.forEach((e) => {
          if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
            systemFoldList.push(e);
          } else {
            foldList.push(e);
          }
        });
        let name = data.name.trimStart().trimEnd();
        if (!name) {
          vm.$refs.warningAddNewFolderDialog.dialog = true;
          vm.warningDetail = 'Please input folder name';
          return;
        }

        // 2021.8.20 203728 SPKA-195 Check dup folder name ( not same FUll Path )
        let foldListCheck = foldList.filter((e) => e.FOLD_PA_ID === data.parentid);
        let checkName = foldListCheck.filter((e) => e.FOLD_NAME === name);
        if (checkName.length > 0) {
          vm.$refs.warningAddNewFolderDialog.dialog = true;
          vm.warningDetail = 'Duplicate folder name';
          return;
        }
      }

      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode, subType }) {
      let status = 'insert';
      let addFolderHeader = {
        header: ['PA_FOLD_ID', 'PA_FOLD_LVL', 'FOLD_NAME'],
        data: [
          {
            PA_FOLD_ID: '',
            PA_FOLD_LVL: '',
            FOLD_NAME: '',
            byProcSetup: true,
          },
        ],
      };
      let updateFolderHeader = {
        data: [
          {
            FOLD_NAME: '',
            FOLD_ID: '',
            byProcSetup: true,
          },
        ],
      };
      let folderList = vm.$store.getters.foldList;
      let systemFoldList = [];
      let foldList = [];
      folderList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          systemFoldList.push(e);
        } else {
          foldList.push(e);
        }
      });
      if (mode === 'import') {
        const isSystem =
          data.FOLD_PA_ID === '0000000000' && data.FOLD_NAME === 'SYSTEM_' + data.FOLD_ID;
        if (isSystem) {
          subType = 'SYSTEM';
          status = 'insert';
          addFolderHeader.data[0].PA_FOLD_ID = '0000000000';
          addFolderHeader.data[0].PA_FOLD_LVL = '0';
          await vm.$store.dispatch('addFolder', addFolderHeader.data[0]).then((response) => {
            data.FOLD_ID = response;
            data.FOLD_NAME = `SYSTEM_${response}`;
            data.FOLD_PATH = `SYSTEM_${response}`;
            console.log('--------- finished ----------');
          });
        } else {
          subType = 'CUSTOM';
          const checkMiss = checkFolder({ FOLD_PATH: data.FOLD_PATH }, foldList);
          if (!checkMiss.isMissing) {
            status = 'duplicate';
            data = checkMiss.item;
          } else {
            status = 'insert';
            const miss = checkMiss.missing || [];
            let chain = Promise.resolve();
            const byLevel = {};
            let lastId = null;

            miss.forEach((e) => {
              chain = chain.then(() => {
                const lvl = e.FOLD_LVL;
                const parentLvl = lvl - 1;

                const paId = e.PA_FOLD_ID ?? byLevel[parentLvl]?.id ?? null;
                const paLvl = e.PA_FOLD_LVL ?? parentLvl;

                addFolderHeader.data[0].PA_FOLD_ID = paId;
                addFolderHeader.data[0].PA_FOLD_LVL = paLvl;
                addFolderHeader.data[0].FOLD_NAME = e.FOLD_NAME;

                return vm.$store.dispatch('addFolder', addFolderHeader.data[0]).then((id) => {
                  byLevel[lvl] = { id };
                  lastId = id;
                });
              });
            });

            await chain.then(() => {
              data.FOLD_ID = lastId;
            });
          }
        }
      }
      if (mode === 'form') {
        if (subType === 'SYSTEM') {
          status = 'insert';
          addFolderHeader.data[0].PA_FOLD_ID = '0000000000';
          addFolderHeader.data[0].PA_FOLD_LVL = '0';
        } else {
          let name = data.name.trimStart().trimEnd();
          if (vm.typeContext === 'Rename') {
            updateFolderHeader.data[0].FOLD_NAME = name;
            updateFolderHeader.data[0].FOLD_ID = data.id;
            status = 'update';
          } else {
            addFolderHeader.data[0].FOLD_NAME = name;
            addFolderHeader.data[0].PA_FOLD_ID = data.parentid;
            addFolderHeader.data[0].PA_FOLD_LVL = data.parentlevel;
            status = 'insert';
          }
        }

        // 05/31/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
        if (status === 'insert') {
          console.log('addFolder: ', addFolderHeader.data[0]);
          // 05/31/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
          await vm.$store.dispatch('addFolder', addFolderHeader.data[0]).then((res) => {
            if (subType === 'SYSTEM') {
              vm.foldId = res;
            } else {
              vm.queryLeftList();
            }
            console.log('--------- finished ----------');
          });
        } else {
          console.log('updateFolder: ', updateFolderHeader.data[0]);
          await vm.$store.dispatch('updateFolder', updateFolderHeader.data[0]).then(() => {
            vm.queryLeftList();
            vm.typeContext = '';
          });
        }
      }

      return { status, data, id: data?.FOLD_ID, subType: subType };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode, subType }) {
      if (mode === 'import') return;
      if (subType === 'SYSTEM') {
        let formEmit = {
          nodeId: vm.nodeId,
          comId: vm.foldId,
          comTp: vm.comTp,
          foldId: vm.foldId,
          foldList: vm.folderList,
          systemFoldList: vm.systemFolderList,
          dirPath: vm.dirPath,
          type: vm.comTp,
        };
        EventBus.$emit('refresh-list-component', formEmit);
      }
    },
  },
  COM: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.$store.getters.communicationSelectBoxList.findIndex(
          (e) =>
            stripSuffix(data.name) === stripSuffix(e.name) &&
            isEqualExcept(data, e, [
              'id',
              'update',
              'updUsrId',
              'value',
              'byProcSetup',
              'name',
              'text',
              'cre_dt',
              'cre_usr_id',
              'comm_comp_id',
              'host_port',
            ]),
        );

        const dupNameIndex = vm.$store.getters.communicationSelectBoxList.findIndex(
          (e) =>
            !isEqualExcept(data, e, [
              'id',
              'update',
              'updUsrId',
              'value',
              'byProcSetup',
              'cre_dt',
              'cre_usr_id',
              'comm_comp_id',
              'host_port',
            ]) && data.name === e.name,
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.$store.getters.communicationSelectBoxList[dupIndex];
        } else if (dupNameIndex > -1) {
          data.name = increaseSuffix(
            vm.$store.getters.communicationSelectBoxList,
            'rename',
            data.name,
          );
          status = 'rename';
          data.id = '';
        } else {
          data.id = '';
        }
      }

      data.byProcSetup = true;

      if (status === 'insert' || status === 'rename') {
        await vm.$store.dispatch('insertCommFromProcSetup', data);
        data.id = vm.$store.getters.communicationId;
      }

      return { status, data, id: data.id };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {},
  },
  MAP: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.mapList.findIndex((e) =>
          isEqualExcept(data, e, [
            'MAP_UPD_DT',
            'MAP_UPD_USR',
            'ROWID',
            'MAPP_VER',
            'MAP_MAPP_CHKIN_YN',
          ]),
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.mapList[dupIndex];
        } else {
          data.MAP_PRCS_NO = '';
        }
      }

      return { status, data, id: data.MAP_PRCS_NO };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {},
  },
  TRIG: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      if (mode === 'form') {
        await new Promise((res) => setTimeout(res, 300));
        const ok = vm.$refs.form.validate();
        if (!ok) return { ok: false, message: 'Please check required fields.' };
      }

      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.$store.getters.triggerSelectBoxList.findIndex(
          (e) =>
            stripSuffix(data.tr_name) === stripSuffix(e.tr_name) &&
            isEqualExcept(data, e, [
              'tr_id',
              'upd_dt',
              'upd_usr_id',
              'value',
              'byProcSetup',
              'tr_name',
              'text',
              'cre_usr_id',
              'cre_dt',
            ]),
        );

        const dupNameIndex = vm.$store.getters.triggerSelectBoxList.findIndex(
          (e) =>
            !isEqualExcept(data, e, [
              'tr_id',
              'upd_dt',
              'upd_usr_id',
              'value',
              'byProcSetup',
              'cre_usr_id',
              'cre_dt',
            ]) && data.tr_name === e.tr_name,
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.$store.getters.triggerSelectBoxList[dupIndex];
        } else if (dupNameIndex > -1) {
          data.tr_name = increaseSuffix(
            vm.$store.getters.triggerSelectBoxList,
            'tr_name',
            data.tr_name,
          );
          status = 'rename';
          data.tr_id = '';
        } else {
          data.tr_id = '';
        }
      }
      if (mode === 'form') {
        status = !data.tr_id ? 'insert' : 'update';
      }
      data.byProcSetup = true;

      if (status === 'insert' || status === 'rename') {
        await vm.$store.dispatch('insertTriggerComponent', data);
        data.tr_id = vm.$store.getters.triggerId;
      } else if (status === 'update') {
        await vm.$store.dispatch('updateTriggerComponent', data);
      }

      return { status, data, id: data.tr_id };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {
      const { status, data } = ctx;

      if (mode === 'import') return;
      EventBus.$emit('refresh-list-component', {
        comId: data.tr_id,
        nodeId: vm.nodeId,
        type: vm.comTp,
      });
      if (status === 'insert') vm.$refs.RegisteredSuccess.dialog = true;
      else vm.$refs.ModifiedSuccess.dialog = true;
    },
  },
  AI: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      if (mode === 'form') {
        await new Promise((res) => setTimeout(res, 300));
        const ok = vm.$refs.form.validate();
        if (!ok) return { ok: false, message: 'Please check required fields.' };
        if (!data.aiNm) return;
        else if (data.aiTp === '') return;
        else if (data.aiEndpoint === '') return;
        else if (data.listFormData.length === 0) {
          vm.add_valid_str = 'Please insert Form Data (at least one)';
          vm.$refs.warningDialog.dialog = true;
          return;
        } else if (data.listHeader.length === 0) {
          vm.add_valid_str = 'Please insert Header (at least one)';
          vm.$refs.warningDialog.dialog = true;
          return;
        } else if (data.aiFooter === '') {
          vm.add_valid_str = 'Please insert Footer';
          vm.$refs.warningDialog.dialog = true;
          return;
        }
        data.aiFormData = '';
        if (data.listFormData.length > 0) {
          let num = data.listFormData.findIndex(
            (e) => !e.key.replace(/\s/g, '').length || !e.value.replace(/\s/g, '').length,
          );
          if (num > -1) {
            vm.hideItem = false;
            let index = data.listFormData[num];
            return vm.$refs[
              `FD_${index.id}${!index.key.replace(/\s/g, '').length ? '' : '_' + index.id}`
            ][0].focus();
          }

          let arrChk = data.listFormData.map((e) => {
            return e.key + e.value;
          });
          let isDuplicate = arrChk.findIndex((e, i) => {
            return arrChk.indexOf(e) != i;
          });

          if (isDuplicate > -1) {
            vm.add_valid_str = 'Duplicate form data.';
            vm.$refs.warningDialog.dialog = true;
            return;
          }

          let aiFormData = '';
          data.listFormData.map((e) => {
            aiFormData += `"${e.key}","${e.value}",`;
          });

          aiFormData = aiFormData.slice(0, aiFormData.length - 1);

          if (aiFormData.length > 200) {
            vm.add_valid_str = 'Max length of API Form Data is 200 characters ';
            vm.$refs.warningDialog.dialog = true;
            return;
          }
          data.aiFormData = aiFormData;
        }

        data.aiHeader = '';
        if (data.listHeader.length > 0) {
          let num = data.listHeader.findIndex(
            (e) => !e.key.replace(/\s/g, '').length || !e.value.replace(/\s/g, '').length,
          );
          if (num > -1) {
            vm.hideItem = false;
            let index = data.listHeader[num];
            return vm.$refs[
              `HEADER_${index.id}${!index.key.replace(/\s/g, '').length ? '' : '_' + index.id}`
            ][0].focus();
          }

          let arrChk = data.listHeader.map((e) => {
            return e.key + e.value;
          });
          let isDuplicate = arrChk.findIndex((e, i) => {
            return arrChk.indexOf(e) != i;
          });

          if (isDuplicate > -1) {
            vm.add_valid_str = 'Duplicate header data.';
            vm.$refs.warningDialog.dialog = true;
            return;
          }

          let aiHeader = '';
          data.listHeader.map((e) => {
            aiHeader += `"${e.key}","${e.value}",`;
          });

          aiHeader = aiHeader.slice(0, aiHeader.length - 1);

          if (aiHeader.length > 200) {
            vm.add_valid_str = 'Max length of API Header is 200 characters ';
            vm.$refs.warningDialog.dialog = true;
            return;
          }
          data.aiHeader = aiHeader;
        }
      }

      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.$store.getters.aiClientSelectBoxList.findIndex(
          (e) =>
            stripSuffix(data.aiNm) === stripSuffix(e.aiNm) &&
            isEqualExcept(data, e, [
              'aiId',
              'updDt',
              'updUsrId',
              'value',
              'byProcSetup',
              'listFormData',
              'listHeader',
              'aiNm',
              'text',
            ]),
        );

        const dupNameIndex = vm.$store.getters.aiClientSelectBoxList.findIndex(
          (e) =>
            !isEqualExcept(data, e, [
              'aiId',
              'updDt',
              'updUsrId',
              'value',
              'byProcSetup',
              'listFormData',
              'listHeader',
            ]) && data.aiNm === e.aiNm,
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.$store.getters.aiClientSelectBoxList[dupIndex];
        } else if (dupNameIndex > -1) {
          data.aiNm = increaseSuffix(vm.$store.getters.aiClientSelectBoxList, 'aiNm', data.aiNm);
          status = 'rename';
          data.aiId = '';
        } else {
          data.aiId = '';
        }
      }
      if (mode === 'form') {
        status = !data.aiId ? 'insert' : 'update';
      }
      data.byProcSetup = true;

      if (status === 'insert' || status === 'rename') {
        await vm.$store.dispatch('insertAIClientFromProcSetup', data);
        data.aiId = vm.$store.getters.aiClientId;
      } else if (status === 'update') {
        await vm.$store.dispatch('editAIClientFromProcSetup', data);
      }

      return { status, data, id: data.aiId };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {
      const { status, data } = ctx;

      if (mode === 'import') return;
      EventBus.$emit('refresh-list-component', {
        comId: data.aiId,
        nodeId: vm.nodeId,
        type: vm.comTp,
      });
      if (status === 'insert') vm.$refs.RegisteredSuccess.dialog = true;
      else vm.$refs.ModifiedSuccess.dialog = true;
    },
  },
  DBA: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.dbAdapterList.findIndex((e) =>
          isEqualExcept(data, e, [
            'dba_child_id',
            'dba_conf_id',
            'dba_id',
            'rowid',
            'dba_mapper_id',
            'upd_dt',
            'upd_user',
            'sql_grp_id',
            'target_agent_id',
            'cre_dt',
            'cre_usr_id',
            'value',
          ]),
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.dbAdapterList[dupIndex];
        } else {
          data.dba_child_id = '';
        }
      }

      return { status, data, id: data.dba_child_id };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {},
  },
  DBAC: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.dbAdapterListHaveChild.findIndex((e) =>
          isEqualExcept(data, e, [
            'dba_child_id',
            'dba_conf_id',
            'dba_id',
            'rowid',
            'dba_mapper_id',
            'upd_dt',
            'upd_user',
            'sql_grp_id',
            'target_agent_id',
            'cre_dt',
            'cre_usr_id',
            'value',
          ]),
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.dbAdapterListHaveChild[dupIndex];
        } else {
          data.dba_child_id = '';
        }
      }

      return { status, data, id: data.dba_child_id };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {},
  },
  USR: {
    // 1. VALIDATE
    async validate(vm, data, { mode }) {
      return { ok: true };
    },

    // 2. SAVE
    async save(vm, data, { mode }) {
      let status = 'insert';
      if (mode === 'import') {
        const dupIndex = vm.$store.getters.userComponentSelectBoxList.findIndex((e) =>
          isEqualExcept(data, e, [
            'uc_id',
            'lock_yn',
            'uc_check_in_user',
            'uc_current',
            'uc_script_id',
            'uc_file_id',
            'file_id',
            'uc_file_comment',
            'upd_dt',
            'upd_user',
            'dep_dt',
            'cre_user',
          ]),
        );

        if (dupIndex > -1) {
          status = 'duplicate';
          data = vm.$store.getters.userComponentSelectBoxList[dupIndex];
        } else {
          data.uc_id = '';
        }
      }

      return { status, data, id: data.uc_id };
    },

    // 3. AFTER SAVE
    async afterSave(vm, ctx, { mode }) {},
  },
};
